import type { ReactNode } from 'react';
import React from 'react';
import { Box } from '@balance-web/box';

export const WidgetContainer = ({
  children,
  forMarketing,
}: {
  children: ReactNode;
  forMarketing?: boolean;
}) => {
  return (
    <Box
      background="base"
      border={forMarketing ? undefined : 'muted'}
      borderRadius={forMarketing ? undefined : 'small'}
      width={forMarketing ? 480 : 400}
    >
      {children}
    </Box>
  );
};
